import { convert } from '../utils'

let lines = [


  {text: ['圣巴巴拉的海里'],startTime: '00:00:01.00', endTime: '00:00:02.15'},
  {text: ['有一种长得很像小刺猬的海胆'],startTime: '00:00:02.16', endTime: '00:00:06.02'},
  {text: ['不要害怕'],startTime: '00:00:06.03', endTime: '00:00:07.07'},
  {text: ['试试把这些小宝贝捧在手上'],startTime: '00:00:07.08', endTime: '00:00:10.23'},
  {text: ['它们虽然长得丑丑的'],startTime: '00:00:10.24', endTime: '00:00:13.18'},
  {text: ['但却有着全加利“孩”尼亚','美丽的心灵'],startTime: '00:00:13.19', endTime: '00:00:17.16'},
  {text: ['来吧 试试用这把','钥匙打开它的心'],startTime: '00:00:17.17', endTime: '00:00:21.17'},
  {text: ['轻轻地 不要弄疼它哦'],startTime: '00:00:21.18', endTime: '00:00:24.12'},
  {text: ['让我们看看它','到底藏了什么秘密吧'],startTime: '00:00:24.13', endTime: '00:00:28.03'},


]

export default convert(lines)
